<template>
  <div v-if="currentRoles.name === '公司管理'" class="page-index system-index">
    <div class="toolbar-box">
      <el-button v-if="currentRoles.roles['公司管理-新增']" class="btn-left" size="mini" @click="openModel(null)">添加公司</el-button>
      <el-button v-if="currentRoles.roles['公司管理-新增集团']" class="btn-left" size="mini" @click="openModel2">添加集团</el-button>
      <div style="flex:1"></div>
      <el-select class="search-input" v-model="status" @change="seach">
        <el-option label="使用中" value="0"></el-option>
        <el-option label="已禁用" value="1"></el-option>
      </el-select>
      <el-input  class="search-input" v-model="query" @keyup.enter.native="seach" placeholder="请输入公司名称" />
    </div>
    <el-table
        ref="table"
        :data="list"
        stripe
        size="mini"
        empty-text="暂无数据"
        row-class-name="table-row-cursor"
        header-row-class-name="header-row"
        :height="tableHeight"
        :maxHeight="tableHeight"
        style="width: 100%;">
      <el-table-column
          header-align="center"
          align="center"
          type="index"
          :index="indexMethod"
          width="50"
          label="#">
      </el-table-column>
      <el-table-column
          header-align="center"
          align="center"
          prop="name"
          label="公司名称">
      </el-table-column>
      <el-table-column
          header-align="center"
          align="center"
          width="100"
          prop="sapCode"
          label="公司代码">
      </el-table-column>
      <el-table-column
          header-align="center"
          align="center"
          prop="address"
          width="200"
          label="生产地址">
      </el-table-column>
      <el-table-column
          header-align="center"
          align="center"
          prop="registerAddress"
          width="200"
          label="注册地址">
      </el-table-column>
      <el-table-column
          header-align="center"
          align="center"
          prop="postcode"
          width="80"
          label="邮编">
      </el-table-column>
      <el-table-column
          header-align="center"
          align="center"
          prop="contactNumber"
          width="120"
          label="联系方式">
      </el-table-column>
      <el-table-column
          header-align="center"
          align="center"
          prop="tel"
          width="120"
          label="传真">
      </el-table-column>
      <el-table-column
          header-align="center"
          align="center"
          prop="createTime"
          width="150"
          label="加入时间">
      </el-table-column>
      <el-table-column
          header-align="center"
          align="center"
          prop="status"
          width="60"
          label="状态">
          <template slot-scope="scope">
            <div>{{scope.row.status == 1 ? '已停用' : '使用中'}}</div>
          </template>
      </el-table-column>
      <el-table-column
          header-align="center"
          align="center"
          width="100"
          label="手动生成批次">
          <template slot-scope="scope">
            <el-switch
              v-model="scope.row.flag"
              @change="isBatchChange(scope.row)"
              active-color="#13ce66"
              inactive-color="#dcdfe6">
            </el-switch>
          </template>
      </el-table-column>
      <el-table-column
          header-align="center"
          align="center"
          width="180"
          label="操作">
        <template slot-scope="scope">
          <div v-if="currentRoles.roles['公司管理-禁用']" style="display:inline-block;margin-right:10px;">
            <el-tooltip v-if="scope.row.status === 0" content="禁用" placement="top">
              <el-button size="mini" @click.stop="handleSwitch(scope.row)" title="禁用">
                <i class="icon el-icon-disable"></i>
              </el-button>
            </el-tooltip>
            <el-tooltip v-if="scope.row.status === 1" content="启用" placement="top">
              <el-button size="mini" @click.stop="handleSwitch(scope.row)">
                <i class="icon el-icon-enable"></i>
              </el-button>
            </el-tooltip>
          </div>
          <el-tooltip v-if="currentRoles.roles['公司管理-编辑']" content="编辑" placement="top">
            <el-button size="mini" @click.stop="openModel(scope.row)">
              <i class="icon el-icon-edit"></i>
            </el-button>
          </el-tooltip>
          <el-tooltip v-if="currentRoles.roles['公司管理-删除']" content="删除" placement="top">
            <el-button size="mini" @click.stop="handleDelete(scope.row)">
              <i class="icon el-icon-delete"></i>
            </el-button>
          </el-tooltip>
        </template>
      </el-table-column>
    </el-table>

    <el-pagination
        :current-page.sync="pageIndex"
        @current-change="pageChange"
        layout="->, total, prev, pager, next"
        :page-size="pageSize"
        :total="total"
        class="pagination">
    </el-pagination>

    <el-dialog
        title="添加公司"
        :visible.sync="dialogVisible"
        width="550px"
        class="model1"
        :before-close="handleClose">
      <el-form ref="organization" :rules="rules" :model="organization">
        <el-row :gutter="20">
          <el-col :span="12">
            <el-form-item label="上级节点" prop="parentId">
              <el-select v-model="organization.parentId" placeholder="请选择上级节点">
                <el-option v-for="item in tree2List" :key="item.id" :label="item.name" :value="item.parentId"></el-option>
              </el-select>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row :gutter="20">
          <el-col :span="12">
            <el-form-item label="公司名称" prop="name">
              <el-input placeholder="请输入公司名称" v-model="organization.name"></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="公司编码" prop="code">
              <el-input placeholder="请输入公司编码" v-model="organization.code"></el-input>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row :gutter="20">
          <el-col :span="12">
            <el-form-item label="生产地址" prop="address">
              <el-input placeholder="请输入生产地址" v-model="organization.address"></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="注册地址" prop="registerAddress">
              <el-input placeholder="请输入注册地址" v-model="organization.registerAddress"></el-input>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row :gutter="20">
          <el-col :span="12">
            <el-form-item label="邮政编码" prop="postcode">
              <el-input placeholder="请输入邮政编码" v-model="organization.postcode"></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="联系方式" prop="contactNumber">
              <el-input placeholder="请输入联系方式" v-model="organization.contactNumber"></el-input>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row :gutter="20">
          <el-col :span="12">
            <el-form-item label="传真">
              <el-input placeholder="请输入传真" v-model="organization.tel"></el-input>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row :gutter="20">
          <el-col :span="12">
            <el-form-item label="品管账号">
              <el-input placeholder="请输入品管账号" v-model="organization.qualityUser.loginCode"></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="密码">
              <el-input placeholder="请输入密码" v-model="organization.qualityUser.password" show-password></el-input>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row :gutter="20">
          <el-col :span="12">
            <el-form-item label="生产账号">
              <el-input placeholder="请输入生产账号" v-model="organization.productUser.loginCode"></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="密码">
              <el-input placeholder="请输入密码" v-model="organization.productUser.password" show-password></el-input>
            </el-form-item>
          </el-col>
        </el-row>
        <div class="flex" v-for="(item, index) in organization.licenseList" :key="item">
          <div class="f1 m20">
            <el-form-item :label="'许可证' + (index + 1)">
              <el-input placeholder="请输入许可证" v-model="item.licenseNumber"></el-input>
              <!-- <el-col class="setting-box2" :span="16">
                <el-input placeholder="请输入许可证" v-model="item.licenseNumber"></el-input>
              </el-col>
              <el-col :span="8">
                <el-button @click.prevent="removeLicense(item, true)">删除</el-button>
              </el-col> -->
            </el-form-item>
          </div>
          <div class="f1">
            <el-button @click.prevent="removeLicense(item, true)">删除</el-button>
          </div>
        </div>
        <div class="addLicense">
          <el-button type="primary" @click="addLicense(true)">增加许可证</el-button>
        </div>
        <!-- <el-form-item label="是否创建管理员账号">
          <el-switch v-model="organization.flag"></el-switch>
        </el-form-item> -->
      </el-form>
      <!-- <el-form v-if="organization.flag" ref="organization2" :rules="rules2" :model="user" label-width="180px">
        <el-form-item label="账号" prop="loginCode">
          <el-input placeholder="请输入账号" v-model="user.loginCode"></el-input>
        </el-form-item>
        <el-form-item label="密码" prop="password">
          <el-input placeholder="请输入密码" v-model="user.password" show-password></el-input>
        </el-form-item>
      </el-form> -->
      <span slot="footer" class="dialog-footer">
        <el-button @click="dialogVisible = false">取 消</el-button>
        <el-button type="primary" @click="handleAdd">确 定</el-button>
      </span>
    </el-dialog>

    <el-dialog
        title="修改公司"
        :visible.sync="dialogVisible2"
        width="550px"
        :before-close="handleClose">
      <el-form ref="organization3" :rules="rules" :model="currentRow" label-width="180px">
        <el-form-item label="公司名称" prop="name">
          <el-input placeholder="请输入公司名称" v-model="currentRow.name"></el-input>
        </el-form-item>
        <el-form-item label="生产地址" prop="address">
          <el-input placeholder="请输入生产地址" v-model="currentRow.address"></el-input>
        </el-form-item>
        <el-form-item label="注册地址" prop="registerAddress">
          <el-input placeholder="请输入注册地址" v-model="currentRow.registerAddress"></el-input>
        </el-form-item>
        <el-form-item label="邮政编码" prop="postcode">
          <el-input placeholder="请输入邮政编码" v-model="currentRow.postcode"></el-input>
        </el-form-item>
        <el-form-item label="联系方式" prop="contactNumber">
          <el-input placeholder="请输入联系方式" v-model="currentRow.contactNumber"></el-input>
        </el-form-item>
        <el-form-item label="传真">
          <el-input placeholder="请输入传真" v-model="currentRow.tel"></el-input>
        </el-form-item>
        <el-form-item :label="'许可证' + (index + 1)" v-for="(item, index) in currentRow.licenseList" :key="item">
          <el-col :span="16">
            <el-input placeholder="请输入许可证" v-model="item.licenseNumber"></el-input>
          </el-col>
          <el-col :span="8">
            <el-button @click.prevent="removeLicense(item, false)">删除</el-button>
          </el-col>
        </el-form-item>
        <el-form-item>
          <el-button type="primary" @click="addLicense(false)">增加许可证</el-button>
        </el-form-item>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button @click="dialogVisible2 = false">取 消</el-button>
        <el-button type="primary" @click="handleEdit">确 定</el-button>
      </span>
    </el-dialog>

    <el-dialog
        title="添加集团"
        :visible.sync="dialogVisible3"
        width="550px"
        :before-close="handleClose">
      <el-form ref="organization4" :rules="rules" :model="organization2" label-width="180px">
        <el-form-item label="上级节点" prop="parentId">
          <el-select v-model="organization2.parentId" placeholder="请选择节点">
            <el-option v-for="item in tree2List" :key="item.id" :label="item.name" :value="item.parentId"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="集团名称" prop="name">
          <el-input placeholder="请输入集团名称" v-model="organization2.name"></el-input>
        </el-form-item>
        <el-form-item label="集团编码" prop="code">
          <el-input placeholder="请输入集团编码" v-model="organization2.code"></el-input>
        </el-form-item>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button @click="dialogVisible3 = false">取 消</el-button>
        <el-button type="primary" @click="handleAdd2">确 定</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script type="text/ecmascript-6">
  import { tableMixin } from '../../mixins/table'
  import { mapGetters } from 'vuex'
  import { formatDate } from '../../utils/common'
  import { apiAdd, apiEdit, apiSwitchStatus, apiDelete, apiDetail, apiList, apiTree, batchChange } from '../../api/organization'

  export default {
    mixins: [tableMixin],
    name: 'system',
    data() {
      return {
        dialogVisible: false,
        dialogVisible2: false,
        dialogVisible3: false,
        list: [],
        pageIndex: 1,
        total: 0,
        query: '',
        status: '0',
        currentRow: {},
        tree2List: [],
        organization: {
          name: '',
          code: '',
          address: '',
          registerAddress: '',
          postcode: '',
          contactNumber: '',
          tel: '',
          licenseList: [],
          qualityUser: {},
          productUser: {},
          parentId: '',
          flag: false
        },
        organization2: {},
        user: {
          loginCode: '',
          password: ''
        },
        rules: {
          name: [
            { required: true, message: '请输入公司名称', trigger: 'blur' },
            { max: 50, message: '长度在 50 个字符以内', trigger: 'blur' }
          ],
          code: [
            { required: true, message: '请输入公司编号', trigger: 'blur' },
            { min: 2, max: 10, message: '长度在 2 到 10 个字符', trigger: 'blur' }
          ],
          address: [
            { required: true, message: '请输入生产地址', trigger: 'blur' },
            { max: 100, message: '长度在 100 个字符以内', trigger: 'blur' }
          ],
          registerAddress: [
            { required: true, message: '请输入注册地址', trigger: 'blur' },
            { max: 100, message: '长度在 100 个字符以内', trigger: 'blur' }
          ],
          postcode: [
            { required: true, message: '请输入邮政编码', trigger: 'blur' }
          ],
          contactNumber: [
            { required: true, message: '请输入联系方式', trigger: 'blur' }
          ],
          parentId: [
            { required: true, message: '请选择节点', trigger: 'change' }
          ]
        },
        rules2: {
          loginCode: [
            { required: true, message: '请输入账号', trigger: 'blur' },
            { min: 6, max: 20, message: '长度在 6 到 20 个字符', trigger: 'blur' }
          ],
          password: [
            { required: true, message: '请输入密码', trigger: 'blur' },
            { min: 6, max: 20, message: '长度在 6 到 20 个字符', trigger: 'blur' }
          ]
        }
      }
    },
    computed: {
      ...mapGetters([
        'userInfo',
        'roles',
        'currentRoles'
      ])
    },
    created() {
      this._getList()
      this._getTree()
    },
    activated() {},
    methods: {
      indexMethod(index) {
        return (this.pageIndex - 1) * 20 + index + 1
      },
      // 打开model
      openModel(row) {
        if (row) {
          this.dialogVisible2 = true
          // this.currentRow = row
          this.getDetail(row.id)
        } else {
          this.organization = {
            name: '',
            code: '',
            address: '',
            registerAddress: '',
            postcode: '',
            contactNumber: '',
            tel: '',
            productUser: {
              loginCode: '',
              password: ''
            },
            qualityUser: {
              loginCode: '',
              password: ''
            },
            licenseList: [{
              licenseNumber: '',
              origin: 1
            }],
            parentId: '',
            isCompany: 1,
            flag: false
          }
          this.dialogVisible = true
          if (this.$refs['organization']) {
            this.$refs['organization'].resetFields()
          }
          if (this.$refs['organization2']) {
            this.$refs['organization2'].resetFields()
          }
          if (this.$refs['organization3']) {
            this.$refs['organization3'].resetFields()
          }
        }
      },
      openModel2() {
        this.organization2 = {
          name: '',
          code: '',
          isCompany: 0,
          parentId: ''
        }
        this.dialogVisible3 = true
        // if (this.$refs['organization4']) {
        //   this.$refs['organization4'].resetFields()
        // }
      },
      // 关闭对话框
      handleClose() {
        this.$confirm('确认关闭？').then(_ => {
          this.dialogVisible = false
          this.dialogVisible2 = false
          this.dialogVisible3 = false
        }).catch(_ => {})
      },
      // 增加许可证
      addLicense(flag) {
        if (flag) {
          this.organization.licenseList.push({
            licenseNumber: '',
            origin: 1
          })
        } else {
          this.currentRow.licenseList.push({
            companyId: this.currentRow.id,
            licenseNumber: '',
            origin: 1
          })
        }
      },
      // 删除许可证
      removeLicense(item, flag) {
        let index = -1
        if (flag) {
          index = this.organization.licenseList.indexOf(item)
          if (index !== -1 && this.organization.licenseList.length > 1) {
            this.organization.licenseList.splice(index, 1)
          }
        } else {
          index = this.currentRow.licenseList.indexOf(item)
          if (index !== -1 && this.currentRow.licenseList.length > 1) {
            this.currentRow.licenseList.splice(index, 1)
          }
        }
      },
      // 翻页
      pageChange(pageIndex) {
        this.pageIndex = pageIndex
        this._getList(pageIndex)
      },
      // 搜索
      seach() {
        this.pageIndex = 1
        this._getList()
      },
      _getTree() {
        this.tree2List = []
        apiTree().then(data => {
          this.tree4mate(data.data)
        })
      },
      tree4mate(data) {
        if (data.isCompany === 0) {
          this.tree2List.push({
            name: data.name,
            parentId: data.id
          })
        }
        if (data.childrenList !== undefined & data.childrenList !== null) {
          data.childrenList.forEach(item => {
            this.tree4mate(item)
          })
        }
      },
      // 获取列表
      _getList(pageIndex = 1) {
        apiList(this.query, this.status, pageIndex).then(data => {
          data.data.data.forEach(item => {
            if (item.isBatch === 1) {
              item.flag = false
            } else {
              item.flag = true
            }
          })
          this.list = data.data.data
          this.total = data.data.total
        })
      },
      // 获取详情
      getDetail(id) {
        apiDetail(id).then(data => {
          this.currentRow = data.data
        })
      },
      // 添加
      handleAdd() {
        let flag = this.organization.flag ? 1 : 0
        this.$refs['organization'].validate((valid) => {
          if (flag === 1) {
            this.$refs['organization2'].validate((valid2) => {
              if (valid && valid2) {
                this.organization.manager = this.user
                this.organization.sapCode = this.organization.code
                apiAdd(this.organization, flag).then(() => {
                  this.$message({
                    type: 'success',
                    message: '添加成功'
                  })
                  this._getList()
                  this.dialogVisible = false
                })
              } else {
                return false
              }
            })
          } else {
            if (this.organization.qualityUser.loginCode === '' || this.organization.qualityUser.password === '') {
              this.$message({
                type: 'warning',
                message: '品管账号信息不完整'
              })
              return
            }
            if (this.organization.productUser.loginCode === '' || this.organization.productUser.password === '') {
              this.$message({
                type: 'warning',
                message: '生产账号信息不完整'
              })
              return
            }
            if (valid) {
              apiAdd(this.organization, flag).then(() => {
                this.$message({
                  type: 'success',
                  message: '添加成功'
                })
                this._getList()
                this.dialogVisible = false
              })
            } else {
              return false
            }
          }
        })
      },
      // 添加集团
      handleAdd2() {
        this.$refs['organization4'].validate((valid) => {
          if (valid) {
            this.organization2.sapCode = this.organization2.code
            apiAdd(this.organization2, 0).then(() => {
              this.$message({
                type: 'success',
                message: '添加成功'
              })
              this._getList()
              this._getTree()
              this.dialogVisible3 = false
            })
          }
        })
      },
      // 修改
      handleEdit() {
        let organization = {
          id: this.currentRow.id,
          name: this.currentRow.name,
          address: this.currentRow.address,
          registerAddress: this.currentRow.registerAddress,
          postcode: this.currentRow.postcode,
          contactNumber: this.currentRow.contactNumber,
          tel: this.currentRow.tel,
          licenseList: this.currentRow.licenseList
        }
        apiAdd(organization).then(() => {
          this.$message({
            type: 'success',
            message: '修改成功'
          })
          this._getList()
          this.dialogVisible2 = false
        })
      },
      // 禁用/启用
      handleSwitch(row) {
        this.$confirm(`是否${row.status === 0 ? '停用' : '启用'}公司：${row.name}`, '提示', {
          confirmButtonText: '确认',
          cancelButtonText: '取消',
          type: 'warning'
        }).then(() => {
          apiSwitchStatus(row.id).then(() => {
            this.$message({
              type: 'success',
              message: `${row.status === 0 ? '停用' : '启用'}成功`
            })
            this._getList()
          })
        })
      },
      // 删除
      handleDelete(row) {
        this.$confirm(`是否删除公司：${row.name}`, '提示', {
          confirmButtonText: '确认',
          cancelButtonText: '取消',
          type: 'warning'
        }).then(() => {
          apiDelete(row.id, 2).then(() => {
            this.$message({
              type: 'success',
              message: '删除成功'
            })
            this._getList()
          })
        })
      },
      // 批次生成方式切换
      isBatchChange(row) {
        batchChange(row.id).catch(() => {
          row.flag = !row.flag
        })
      }
    }
  }
</script>

<style lang="stylus">
  .page-index.system-index
    .btn-left
      background #A5CE1C
      color #fff
    .toolbar-box
      display flex
      margin 10px 0
      .search-input
        width 150px
        margin-right 10px
    .el-form-item__content
      width 200px
    .model1
      .el-select
        width 100%
      .el-form-item__content
        width 100%
      .flex
        display flex
      .f1
        flex 1
        position relative
        button
          position absolute
          bottom 0
      .m20
        margin-right 20px
      .el-form-item
        margin-bottom 0
      .addLicense
        margin-top 15px
</style>
